
import React from "react";

interface AuthModeSelectorProps {
  isSignUp: boolean;
  setIsSignUp: (value: boolean) => void;
}

export const AuthModeSelector = ({ isSignUp, setIsSignUp }: AuthModeSelectorProps) => {
  return (
    <div className="text-center">
      <button
        type="button"
        onClick={() => setIsSignUp(!isSignUp)}
        className="text-gameGold hover:underline"
      >
        {isSignUp
          ? "Already have an account? Sign in"
          : "Need an account? Sign up"}
      </button>
    </div>
  );
};
